import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "25c4d6f0-58ca-492c-9c57-3b6436d81ac9",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText:
      "Input the value of the <b>resonance frequency</b> (rounded to the first decimal place,the speed of sound is equal to 340 m/s):",
    unit: "Hz",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 87,
};
